import { render, staticRenderFns } from "./mailling-sent.vue?vue&type=template&id=390db366&scoped=true"
import script from "./mailling-sent.vue?vue&type=script&lang=js"
export * from "./mailling-sent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390db366",
  null
  
)

export default component.exports